<template>
    <div class="brandIdBlock">
        <el-button type="primary" v-if="!batchBrand" @click="useBrandConf" style="margin-bottom: 10px">一键应用品牌配置</el-button>
        <!-- <pre>{{shopList}}</pre> -->
        <div class="brandId-row" v-for="shop in shopList" :key="shop.id">
            <el-image
                :src="shop.icon"
                style="width: 26px; height: 26px;  border-radius: 50%"
            ></el-image>
            <el-tooltip v-if="shop.channelIcon" :content="shop.channelName" style="margin: 0px -6px 0px 6px;">
                <el-image :src="shop.channelIcon" style="width: 18px; height: 18px;"></el-image>
            </el-tooltip>
            <span class="shop-title">{{ shop.simpleTitleConfig === 1 ? (shop.shortTitle || shop.title ): shop.title }}</span>
            <el-select
                :value="valueMap[shop.id]"
                value-key="brandId"
                name-key="brandName"
                :loading="loading[shop.id]"
                filterable
                remote
                :remote-method="($event) => remoteMethod($event, shop.id)"
                @change="(v) => selectChange(v, shop.id)"
                @visible-change="e => selectVisible(shop.id, e)"
                >
                <el-option
                    v-for="brandOp in brandOptions[shop.id]"
                    :key="brandOp.brandId"
                    :label="brandOp.brandName"
                    :value="brandOp">
                </el-option>
            </el-select>
            <el-link 
                v-if="valueMap && valueMap[shop.id] && valueMap[shop.id].brandName && !batchBrand"
                style="margin-left: 8px" 
                @click="handleSetToShop(shop,valueMap && valueMap[shop.id] && valueMap[shop.id].brandName)"
                >应用到其他店铺</el-link
                >
            <el-link v-if="!batchBrand" href="https://seller.shop.jd.com/venderBrand/venderBrand_list.action" target="_blank" style="margin-left: 10px;">申请新品牌</el-link>
            <span v-if="getFail[shop.id]" class="error-text">{{ getFail[shop.id] === true ? '店铺订购应用已过期，请重新订购以获取店铺品牌' : getFail[shop.id] }}</span>
        </div>
        <el-dialog-select-shop
            :visible.sync="shopDialogVisible"
            :shopData="shopList"
            :selected="selectShopIds"
            placeholder="店铺名称"
            @confirm="confirmSelectShop"
        ></el-dialog-select-shop>
        <div class="tips" v-if="!batchBrand">注：京东官方要求部分类目的商品标题必须是商品的品牌词，不计入商品标题总字数<el-link href="https://jos.jd.com/platformdetail?listId=328&itemId=2215" target="_blank">查看平台公告</el-link></div>
    </div>
</template>

<script>
import { getVenderBrandListByshopId } from '@/servers/prod/center/jd.js'
import { cloneDeep } from 'lodash';
import { ApplyToOtherShop } from '@/servers/prod/center/fxg.js';
const PLATFORMID = 'JdShop'
import { getApplyBrandConfig } from '@/servers/prod/center/pdd.js';
import { detailByBaseItemId } from '@/api/distributor';

export default {
    name: 'jdBrandIdBlock',
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        shopList: {
            type: Array,
            default() {
                return []
            }
        },
        value: {
            type: Array,
            default() {
                return []
            }
        },
        categoryIds: {
            type: Array,
            default() {
                return []
            }
        },
        baseItemId: [String, Number],
        batchBrand: {
            type: Boolean,
            default() {
                return false
            }
        },
    },
    data() {
        return {
            valueMap: {},
            originOptions: {},
            brandOptions: {},
            loading: {},
            getFail: {},
            categoryId: '',
            shopDialogVisible:false,
            selectShopIds: '',
            applyShopName:'',//发货时效应用的店铺名称
            applyShopObj:[],//发货时效应用的店铺对象

        }
    },
    watch: {
        value: {
            immediate: true,
            handler(v) {
                if (v && v.length) {
                    v.forEach(item => {
                        this.$set(this.valueMap, item.shopId, item);
                    })
                }
            }
        },
        categoryIds: {
            handler(v) {
                this.categoryId = v.length > 3 ? v[2] : v[v.length - 1]
                this.$set(this, 'brandOptions', {});
            },
            immediate: true,
        },
    },
    methods: {
         extractContent(str) {
            // 使用正则表达式匹配括号内的内容
            const match = str.match(/（([^）]+)）/);

            // 如果匹配到括号内的内容，返回括号内的部分；否则，返回整个字符串
            return match ? match[1] : str;
        },
        method_validate() {
            let hasVoid = false;
            let getFail = {};
            this.shopList.forEach(shop => {
                if (!this.valueMap[shop.id]) {
                    hasVoid = true
                    getFail[shop.id] = '请选择品牌'
                }
            })
            this.getFail = getFail;
            return hasVoid
        },
        selectVisible(shopId, visible) {
            if(visible) {
                if (!this.brandOptions[shopId]) {
                    this.getVenderShopBrandList(shopId)
                }
            } else {
                if (this.originOptions[shopId]) {
                    this.brandOptions[shopId] = cloneDeep(this.originOptions[shopId]);
                }
            }
        },
        selectChange(v, shopId) {
            console.log(cloneDeep(this.value), cloneDeep(v), cloneDeep(this.valueMap), '--this.value---v--this.valueMap-')
            let newVal = cloneDeep(this.value);
            let oindex = newVal.findIndex(({shopId}) => shopId === v.shopId)
            v.channel = this.shopList.find(shop => shop.id == shopId)?.channel || "KMERP"
            if (oindex > -1) {
                newVal.splice(oindex, 1, v)
            } else {
                newVal.push(v)
            }
            console.log(newVal,167);
            this.$emit('change', newVal)
        },
        remoteMethod(queryText, shopId) {
            queryText = (queryText || '').trim()
            if (!queryText) {
                this.brandOptions[shopId] = cloneDeep(this.originOptions[shopId]);
                return false;
            }
            this.getVenderShopBrandList(shopId, queryText)
        },
        async getVenderShopBrandList(id, brandName='') {
            this.$set(this.loading, id, true)
            this.getFail = {};
            try {
                let list = await getVenderBrandListByshopId({shopId: id, categoryId: this.categoryId, brandName})
                this.loading[id] = false;
                if (!list) {
                    this.$set(this.getFail, id, true)
                    list = []
                } else {
                    list = list.map(item => {
                        return {
                            shopId: id,
                            brandId: item.erpBrandId,
                            brandName: item.brandName
                        }
                    })
                }
                
                const findNoBrand = list.find(item => item.brandId == -1 || item.brandName === '无品牌')
                if(!findNoBrand) {
                    list.unshift({
                        shopId: id,
                        brandId: -1,
                        brandName: '无品牌'
                    })
                }
                this.$set(this.brandOptions, id, cloneDeep(list))
                if(!brandName) {
                    this.$set(this.originOptions, id, cloneDeep(list))
                }
            } catch (error) {
                console.log(error, '-----error')
            }
            
        },
        handleSetToShop(promiseConf,applyShopName){
            this.applyShopObj = promiseConf
            this.shopDialogVisible = true;
            this.applyShopName = applyShopName
        },
        getCategoryId() {
            let leafCategoryId = '';
            const categoryIds = this.categoryIds;
            if (categoryIds && categoryIds.length) {
                leafCategoryId = categoryIds[categoryIds.length - 1];
            }
            return leafCategoryId;
        },
        // 修改类目时初始化数据
        async useBrandConfInit() {
            const categoryId = this.getCategoryId();
            const categoryBrandRelations = await getApplyBrandConfig({ categoryId, baseItemId: this.baseItemId, shopType: PLATFORMID });

            let valueMap = {};
            let newVal = [];
            // 新增逻辑：检查是否有未匹配的 shopId
            const unmatchedShopIds = this.shopList
                .map(shop => shop.id)
                .filter(shopId => !categoryBrandRelations.some(item => item.shopId === shopId && item.relations.find(item=>item.categoryId == categoryId)));
            if (unmatchedShopIds.length > 0) {
                // 调用 getApplyToOtherShop 接口获取数据
                const res = await this.getApplyToOtherShop({
                shopType: PLATFORMID,
                shopIds: unmatchedShopIds.join(','),
                categoryId: (categoryId),
                });
                // 将返回的数据进行匹配
                unmatchedShopIds.forEach(shopId => {
                const shopData = res[shopId];
                if (shopData) {
                    const newItem = {
                        brandId: shopData.vid,
                        brandName: shopData.vvalue,
                        shopId,
                        channel:'KMERP'
                    };
                    valueMap[shopId] = newItem;
                    newVal.push(newItem);
                }
                });
            }
            this.shopList.forEach(shop => {
                const shopId = shop.id;
                let relations = (categoryBrandRelations.find(item => shopId === item.shopId) || {}).relations || [];
                let valueItem = relations.find(item => item.categoryId == categoryId);
                if (valueItem) {
                let newItem = {
                    brandId: valueItem.vid,
                    brandName: valueItem.vvalue,
                    shopId,
                    channel:'KMERP'
                };
                valueMap[shopId] = newItem;
                newVal.push(newItem);
                }
            });
            Object.keys(valueMap).forEach(shopId => {
                if (!valueMap[shopId]) {
                valueMap[shopId] = valueMap[shopId];
                newVal.push(valueMap[shopId]);
                }
            })
            console.log(valueMap,newVal);
            this.$set(this, 'valueMap', valueMap);
            this.$emit('change', newVal);
        },
            async useBrandConf() {
            const categoryId = this.getCategoryId();
            const valueMapShopIds = Object.keys(this.valueMap)
            const emptyShopIds = this.shopList.filter(item=>!valueMapShopIds.some(valueMapItem=>item.id == valueMapItem)).map(item=>item.id)
            // console.log(emptyShopIds,262);
            const brandParams = {
                categoryId, 
                baseItemId: this.baseItemId, 
                shopType: PLATFORMID,
            }
            const categoryBrandRelations = await getApplyBrandConfig(brandParams);
            // console.log(categoryBrandRelations,270);
            
            let valueMap = {};
            let newVal = [];
            this.shopList.forEach(shop => {
                const shopId = shop.id;
                let relations = (categoryBrandRelations.find(item => shopId == item.shopId) || {}).relations || [];
                let valueItem = relations.find(item => item.categoryId == categoryId);
                let isExistValueItem = Object.keys(this.valueMap)
                if (valueItem && !isExistValueItem.includes(String(shop.id))) {
                let newItem = {
                    brandId: valueItem.vid,
                    brandName: valueItem.vvalue,
                    shopId,
                    channel:'KMERP'
                };
                valueMap[shopId] = newItem;
                newVal.push(newItem)
                }
            });
            // 新增逻辑：检查是否有未匹配的 shopId
            let unmatchedShopIds = this.shopList
                    .map(shop => shop.id)
                    .filter(shopId => !categoryBrandRelations.some(item => item.shopId == shopId && item.relations.find(item=>item.categoryId == categoryId)));
                    const test = categoryBrandRelations.filter(item=>item.relations.find(item=>item.categoryId == categoryId))
                    console.log(unmatchedShopIds,265,test,this.valueMap);
                    
                if (unmatchedShopIds.length > 0) {
                    // 调用 getApplyToOtherShop 接口获取数据
                    const res = await this.getApplyToOtherShop({
                        shopType: PLATFORMID,
                        shopIds: unmatchedShopIds.join(','),
                        categoryId: categoryId,
                    });
                    // 将返回的数据进行匹配
                    res &&  Object.keys(res).forEach(shopId => {
                        const shopData = res[shopId];
                        if(Object.keys(this.valueMap).includes(shopId)) return
                        if (shopData) {
                        const newItem = {
                            brandId: shopData.vid,
                            brandName: shopData.vvalue,
                            shopId,
                            channel:'KMERP'
                        };
                        valueMap[shopId] = newItem;
                        newVal.push(newItem);
                        }
                    });
                }
            const _valueMap = Object.assign({},this.valueMap,valueMap)
            //   console.log(_valueMap,298);
            this.$set(this, 'valueMap', _valueMap);

            Object.keys(_valueMap).forEach(shopId => {
                const index = newVal.findIndex((item) => shopId == item.shopId);
                if (index == -1) {
                newVal.push(_valueMap[shopId])
                }
            })
            //   console.log(this.valueMap,newVal,valueMap,305);
            this.$emit('change', newVal)
        },
        confirmSelectShop(shops){
        this.shopDialogVisible = false
            this.$confirm(`选中店铺将匹配品牌【${this.applyShopName}】，匹配后将覆盖原品牌值，未匹配到将跳过，是否确认`, '提示', {
                confirmButtonText: '确定',
                type: 'warning'
            }).then(async() => {
                const shopIds = shops.map(item=>item.id)
                // const brandName = this.applyShopName? this.extractContent(this.applyShopName):''
                const params = {
                    shopType: PLATFORMID,
                    shopIds:shopIds.join(','),
                    categoryId: this.categoryId,
                    brandName: this.applyShopName,
                }
                const res = await this.getApplyToOtherShop(params)
                const dataKeys = Object.keys(res)
                // for(const key in this.valueMap){
                //     if(dataKeys.includes((key))){
                //     const shopInfo = res[key];
                //     this.valueMap[key] = {...shopInfo,shopId: key}
                //     }
                    
                // }
                    const newValue = []
                // 处理接口返回的数据
                for(const key in res){
                    const shopInfo = res[key];
                    this.valueMap[key] = { 
                        brandId: shopInfo.vid,
                        brandName: shopInfo.vvalue,
                        shopId: Number(key),
                        // channel: "KMERP"
                        }
                    newValue.push({
                        brandId: shopInfo.vid,
                        brandName: shopInfo.vvalue,
                        shopId: Number(key),
                    }) 

                }
                // 去除接口返回的数据，其他的按照之前的value处理即可
                this.value.map(item => {
                    const index = newValue.findIndex(({ shopId }) => shopId == item.shopId);
                    if (index == -1) {
                    newValue.push(item)
                    }
                })
                this.$emit('change',newValue)
                this.$message.success('更新品牌成功！')
                
            }).catch(() => {
                // this.$message.error('更新品牌失败！')
            });

        },
        async getApplyToOtherShop(payload){
            const params = {
                ...payload,
            }
            const res =  await ApplyToOtherShop(params)
            return res
        },
    },
}
</script>

<style lang="scss" scoped>
.brandId-row {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}
.error-text {
    color: #F56C6C;
    font-size: 12px;
    margin-left: 10px;
}
</style>